// extracted by mini-css-extract-plugin
export var contentNav = "mobile-sidebar-module--contentNav--9aada";
export var contentNavHidden = "mobile-sidebar-module--contentNavHidden--b0424";
export var mobileHeader = "mobile-sidebar-module--mobileHeader--26dae";
export var mobileLogo = "mobile-sidebar-module--mobileLogo--48d12";
export var mobileLogoContainer = "mobile-sidebar-module--mobileLogoContainer--b17d3";